import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  loadingManageCategoryLanguage: false,
  getCategoryLanguage: null,
  parentCategoryList: null,
  parentCategoryListError: null,
  parentCategoryLoading: false,
  parentCategory: null,
  parentCategoryDataError: null,
  childCategoryList: null,
  childCategoryListError: null,
  childCategoryLoading: false,
  childCategory: null,
  childCategoryDataError: null,
  getSeo:null,
  getSeoError:null,
  success: null,
  error: null, 
  successManageCategoryLanguage: null,
  errorManageCategoryLanguage: null, 
};
export const categoryReducer = (state = initialState, action) => { 
  switch (action.type) {
    case actionTypes.GET_PARENT_CATEGORY_LIST_START:
      return { ...state, loading: true, parentCategoryListError: null, parentCategoryList: null, getSeo:null,getSeoError:null};
    case actionTypes.GET_PARENT_CATEGORY_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        parentCategoryListError: null,
        parentCategoryList: action.payload,
      };
    };
    case actionTypes.GET_PARENT_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        parentCategoryListError: action.payload,
        parentCategoryList: null,
      };
    case actionTypes.GET_CHILD_CATEGORY_LIST_START:
      return { ...state, loading: true, childCategoryListError: null, childCategoryList: null,getSeo:null,getSeoError:null};
    case actionTypes.GET_CHILD_CATEGORY_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        childCategoryListError: null,
        childCategoryList: action.payload,
      };
    };
    case actionTypes.GET_CHILD_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        childCategoryListError: action.payload,
        childCategoryList: null,
      };
    case actionTypes.ADD_CATEGORY_START:
      return { ...state, loading: true, success: null, error: null };
    case actionTypes.ADD_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: null
      };
    case actionTypes.ADD_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        success: null,
        error: action.payload
      }; 
    case actionTypes.UPDATE_CATEGORY_START:
      return { ...state, loading: true, success: null, error: null };
    case actionTypes.UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: null
      };
    case actionTypes.UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,   
        success: null,
      }; 
    case actionTypes.ADD_CATEGORY_LANGUAGE_START:
      return { ...state, loadingManageCategoryLanguage: true, successManageCategoryLanguage: null, errorManageCategoryLanguage: null };
    case actionTypes.ADD_CATEGORY_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        successManageCategoryLanguage: action.payload.message,
        errorManageCategoryLanguage: null
      };
    case actionTypes.ADD_CATEGORY_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        errorManageCategoryLanguage: action.payload,   
        successManageCategoryLanguage: null,
      };
    case actionTypes.GET_CATEGORY_LANGUAGE_START:
      return { ...state, loadingManageCategoryLanguage: true, successManageCategoryLanguage: null, errorManageCategoryLanguage: null, getCategoryLanguage: null };
    case actionTypes.GET_CATEGORY_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        errorManageCategoryLanguage: null,
        getCategoryLanguage: action.payload
      };
    case actionTypes.GET_CATEGORY_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        errorManageCategoryLanguage: action.payload,   
        getCategoryLanguage: null
      };
    case actionTypes.UPDATE_CATEGORY_LANGUAGE_START:
      return { ...state, loadingManageCategoryLanguage: true, successManageCategoryLanguage: null, errorManageCategoryLanguage: null };
    case actionTypes.UPDATE_CATEGORY_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        successManageCategoryLanguage: action.payload.message,
        errorManageCategoryLanguage: null
      };
    case actionTypes.UPDATE_CATEGORY_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageCategoryLanguage: false,
        errorManageCategoryLanguage: action.payload,   
        successManageCategoryLanguage: null,
      };

    // case actionTypes.DELETE_RESTAURANT_START:
    //   return { ...state, loading: true, success: null, error: null };
    // case actionTypes.DELETE_RESTAURANT_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     success: action.payload.message,
    //     successMessage: "Record deleted successfully",
    //     error: null
    //   };
    // case actionTypes.DELETE_RESTAURANT_FAILURE:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.payload,   
    //     success: null,
    //   }; 




    
    case actionTypes.MESSAGE_HANDLER:
      return {
        ...state,
        loading: false,
        loadingManageCategoryLanguage: false,
        parentCategoryListError: action.payload,
        parentCategoryDataError: action.payload,
        childCategoryListError: action.payload,
        childCategoryDataError: action.payload,
        error: action.payload,
        success: action.payload,
        errorManageCategoryLanguage: action.payload,
        successManageCategoryLanguage: action.payload,
      };
    default:
      return { ...state };
  }
};
